var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HeaderModal"
  }, [_c('h1', {
    staticClass: "HeaderModal-title",
    attrs: {
      "id": "js-header-modal-title",
      "aria-label": _vm.title,
      "tabindex": "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('button', {
    staticClass: "HeaderModal-close Accessibility",
    attrs: {
      "aria-label": _vm.$t('button.close'),
      "type": "button"
    },
    on: {
      "click": _vm.hideModal,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hideModal.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.hideModal.apply(null, arguments);
      }]
    }
  }, [_c('span', {
    staticClass: "HeaderModal-closeIcon common-cross"
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }